module.exports = __webpack_public_path__ + "static/financial_access3-a6e0e3d5c154faf1cab20c2590c67951.png";